//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageViewer from '../../components/Images/ImageViewer.vue'
export default {
  name: 'WaybillFlightPhotos',
  components: {
    ImageViewer: ImageViewer
  },
  props: {
    photos: {
      type: Array,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    allowSelection: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    selectedPhotos: {
      type: Array,
      default: null
    },
    selectedPhoto: {
      type: Number,
      default: null
    },
    markNonSelectable: {
      type: Boolean,
      default: false
    },
    useSelectablePhotoProp: {
      type: Boolean,
      default: false
    },
    useCaptions: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      fullscreen: false,
      fullscreenPhoto: 0,
      localSelectedPhotos: JSON.parse(JSON.stringify(this.selectedPhotos)),
      localSelectedPhoto: this.selectedPhoto,

      disabledTrueVal: true
    }
  },
  watch: {
    localSelectedPhoto: {
      handler: function (value) {
        this.$emit('select-photo', value)
      }
    },
    selectedPhotos: {
      handler: function (value) {
        this.localSelectedPhotos = JSON.parse(JSON.stringify(this.selectedPhotos))
      }
    }
  },
  methods: {
    onShowPreview: function (images, index) {
      this.$refs.viewer.show(images, index)
    },
    onSelectPhotos: function () {
      this.$emit('select-photo', this.localSelectedPhotos)
    }
  }
}
